import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Heading, HeadingKindType, HeadingLevelType } from '@savebetter/components';

interface PageSectionHeaderProps {
  className?: string;
  headingKind?: HeadingKindType;
  headingLevel?: HeadingLevelType;
  children?: React.ReactNode;
}

export const PageSectionHeader: FunctionComponent<React.PropsWithChildren<PageSectionHeaderProps>> = ({
  children,
  className,
  headingKind = '2',
  headingLevel = '2'
}) => {
  const id = typeof children === 'string' ? children?.toLowerCase().replace(/\W/g, '_') : Math.random().toString();
  return (
    <Heading
      className={classnames('text-left md:text-center font-normal', className)}
      level={headingLevel}
      kind={headingKind}
      id={id}
    >
      {children}
    </Heading>
  );
};
